import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=327e13c1&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e13c1",
  null
  
)

export default component.exports